import { useMediaQuery } from 'react-responsive';
/**
 * @param {string | undefined} query - media query string
 * @param {boolean} fallback - fallback return valu in case server side (!window)
 * @return {boolean} result - useMediaQuery for client, falback for server
*/
export const useFallbackMediaQuery = (query, fallback) => {
    const mediaQueryByWindow = useMediaQuery({ query });
    if (typeof window !== 'undefined') {
        return mediaQueryByWindow;
    }
    else {
        return fallback ?? false;
    }
};
//# sourceMappingURL=FallbackMediaQuery.js.map